import { ComponentsProps, ComponentsOverrides, ComponentsVariants, formLabelClasses, Theme } from '@mui/material';

export const MuiFormLabel: {
    defaultProps?: ComponentsProps['MuiFormLabel'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormLabel'];
    variants?: ComponentsVariants['MuiFormLabel'];
} = {
    styleOverrides: {
        root: (props) => ({
            [`&.${formLabelClasses.disabled}`]: {
                color: props.theme.palette.text.primary,
            },
            [`&.${formLabelClasses.focused}`]: {
                color: props.theme.palette.text.primary,
            },
            [`&.${formLabelClasses.error}`]: {
                color: props.theme.palette.error.main,
            },
        }),
        asterisk: (props) => ({
            color: props.theme.palette.error.main,
        }),
    },
};

export const MuiFormControlLabel: {
    defaultProps?: ComponentsProps['MuiFormControlLabel'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormControlLabel'];
    variants?: ComponentsVariants['MuiFormControlLabel'];
} = {
    styleOverrides: {
        root: () => ({
            marginLeft: 0,
            marginRight: 0,
        }),
        label: (props) => ({ marginLeft: props.theme.spacing(props.theme.tokens.spacing.xs) }),
        asterisk: (props) => ({
            color: props.theme.palette.error.main,
        }),
    },
};
